<template>
  <div class="row">
    <div class="col-lg-12 col-xxl-12">
      <div class="card card-custom card-stretch gutter-b">
        <div class="card-header border-0 py-5">
          <h3 class="card-title align-items-start flex-column"></h3>
          <div class="card-toolbar"></div>
        </div>
        <div class="d-flex justify-content-center w-100">
          <div class="location-container">
            <GmapMap :center="gmap.center" :zoom="8" class="location-map">
              <GmapMarker :key="index" v-for="(m, index) in gmap.markers" :position="m.position" :clickable="true"
                :draggable="false" :icon="{ url: 'media/logos/iconmarker.png' }" @click="openWindow($event, index)" />
              <GmapInfoWindow @closeclick="gmap.window_open = false" :opened="gmap.window_open"
                :position="gmap.infowindow" :options="{
                  pixelOffset: {
                    width: 0,
                    height: -35,
                  },
                }">
                <!-- <v-img width="150" height="150" :src="`${image_url}${gmap.image}`"></v-img> -->
                <div class="group-info text-center">
                  <div class="group-name pt-2">
                    <a v-if="gmap.info_url" :href="gmap.info_url" target="_blank">{{ gmap.info_marker }}</a>
                    <span v-else>{{ gmap.info_marker }}</span>
                  </div>

                  <div class="group-address">
                    {{ gmap.address }}
                  </div>
                </div>
              </GmapInfoWindow>
            </GmapMap>
          </div>
        </div>
        <b-row class=" mt-10 ml-5 mr-5">
          <b-col sm="7">
            <b-form-group>
              <b-input-group size="sm">
                <b-form-input v-model="pagination.filter" :placeholder="$t('PAGE.DEFAULT.TABLE.SEARCH')" type="search"
                  id="filterInput" debounce="500" @update="fetchData()"></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!pagination.filter" @click="
                    pagination.filter = '';
                  fetchData();
                  ">{{ $t("PAGE.DEFAULT.TABLE.CLEAR") }}</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col sm="5">
            <b-button variant="primary" class="float-right" style="padding-top: 6px; padding-bottom: 6px"
              v-on:click.prevent="$router.push('mangrove_info/form')">
              {{ $t("PAGE.DEFAULT.TABLE.NEW") }}
            </b-button>
          </b-col>
        </b-row>
        <div class="card-body pt-0 pb-3 mt-4">
          <div class="tab-content">
            <div class="table-responsive">
              <b-table id="organizations-table" :striped="false" :items="items" :fields="fields"
                :sort-by.sync="pagination.orderBy" :sort-desc.sync="pagination.isDesc" :no-sort-reset="true"
                :busy.sync="isBusy" :loading="false" :borderless="true" head-variant="light" :no-local-sorting="true"
                @sort-changed="sortChange">


                <template #cell(name)="data">
                  <div class="d-flex align-items-center">

                    <div>
                      <a href="javascript:" class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">{{ data.value}}</a>
                    </div>
                  </div>
                </template>

                <template #cell(action)="data">
                  <a href="javascript:" @click.prevent="$router.push(`mangrove_info/form/${data.item.id}`)  ,setDataId(data.item.id) "
                    class="btn btn-icon btn-light btn-sm" v-b-tooltip.hover
                    :title="$t('PAGE.DEFAULT.TABLE.FIELDS.ACTION.EDIT')">
                    <span class="svg-icon svg-icon-md svg-icon-primary">
                      <inline-svg src="media/svg/icons/General/Edit.svg"></inline-svg>
                    </span> </a>&nbsp;&nbsp;&nbsp;
                  <a href="javascript:" @click.prevent="removeData(data.item.id)" class="btn btn-icon btn-light btn-sm"
                    v-b-tooltip.hover :title="$t('PAGE.DEFAULT.TABLE.FIELDS.ACTION.DELETE.TITLE')">
                    <span class="svg-icon svg-icon-md svg-icon-primary">
                      <inline-svg src="media/svg/icons/General/Trash.svg"></inline-svg>
                    </span>
                  </a>
                </template>
              </b-table>
              <p class="text-center pt-3" v-if="items.length < 1">
                {{ $t("PAGE.DEFAULT.TABLE.DATA_NOT_FOUND") }}
              </p>
            </div>
            <div class="row justify-content-between">
              <div div class="col-lg-2">
                <b-form-group id="name-input-group" :label="$t('PAGE.DEFAULT.TABLE.PER_PAGE')" label-for="name-input"
                  label-cols="7" label-align-sm="left" label-size="lg">
                  <b-form-select v-model="pagination.perPage" id="perPageSelect" size="sm" :options="paginationOptions"
                    @change="fetchData()"></b-form-select>
                </b-form-group>
              </div>
              <div div class="col-lg-2">
                <b-pagination v-model="pagination.page" :total-rows="total" :per-page="pagination.perPage"
                  @input="fetchData()" align="right"></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.b-table th {
  background-color: #840000 !important;
  color: #ffff !important;
}

.location-container {
  width: 90%;
}

.location-map {
  width: 100%;
  height: 500px;
  border-radius: 4px;
  border: 1px solid #fff;
}

.idField {
  min-width: 100px;
  width: 10%;
  max-width: 100px;
}

.fullNameField {
  min-width: 100px;
  width: 30%;
  max-width: 100px;
}

.emailField {
  min-width: 100px;
  width: 40%;
  max-width: 100px;
}
.actionField {
  min-width: 100px;
  width: 45%;
  max-width: 100px;
}

.actionField {
  min-width: 100px;
  width: 10%;
  max-width: 100px;
}

</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Swal from "sweetalert2";
import {
  PAGINATION_MANGROVE_LOCATION_DATA,
  SET_PAGINATION,
  SET_IS_CLEAR_PAGINATION,
  CLEAR_PAGINATION,
  PUT_MANGROVE_LOCATION_STATUS_DATA,
  DELETE_MANGROVE_LOCATION_DATA,
   SET_STATE_PRAM_M_LOCATION
} from "@/core/services/store/mangrove_location.module";
import { mapState } from "vuex";
import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCb-Cr081cGsWBbI8agi4iNQPJK0qcnCI8',
    libraries: 'places',
  },
})

export default {
  data() {
    return {
      fields: [
        {
          key: "name",
          label: `${this.$t("PAGE.MANGROVE.TABLE.FIELDS.NAME")}`,
          key_table: "name",
          sortable: true,
          isFilter: true,
          tdClass: "fullNameField"
        },
        {
          key: "iot.sensor_name",
          label: `${this.$t("PAGE.MANGROVE.TABLE.FIELDS.NAMESENSOR")}`,
          key_table: "iot.sensor_name",
          sortable: true,
          isFilter: false,
          tdClass: "fullNameField"
        },
                {
          key: "iot.api_url",
          label: `${this.$t("PAGE.MANGROVE.TABLE.FIELDS.IP")}`,
          key_table: "iot.api_url",
          sortable: true,
          isFilter: false,
          tdClass: "fullNameField"
        },

        {
          key: "action",
          label: `${this.$t("PAGE.MANGROVE.TABLE.FIELDS.MORE")}`,
          sortable: false,
          isFilter: false,
          tdClass: "actionField"
        }
      ],
      select: [
          '*',
          'mangrove_location.id',
          'mangrove_location.name',
      ],
      paginationOptions: [25, 50, 100, 200],
      isBusy: false,
      items: [],
      total: 0,
      include: ["iot"],
      gmap: {
        center: { lat: Number(11.0), lng: Number(11.0) },
        markers: [],
        info_marker: null,
        infowindow: { lat: Number(11.0), lng: Number(11.0) },
        window_open: false,
        info_url: null,
        image: '',
        address: '',
      },
    };
  },
  computed: {
    ...mapState({
      userType: state => state.auth.userType
    }),
    isClearPagination: {
      get() {
        return this.$store.state.user.isClearPagination;
      },
      set(value) {
        this.$store.commit(SET_IS_CLEAR_PAGINATION, {
          isClearPagination: value
        });
      }
    },
    pagination: {
      get() {
        return this.$store.state.user.pagination;
      },
      set(value) {
        this.$store.commit(SET_PAGINATION, { pagination: value });
      }
    }
  },
  mounted() {

    this.$store.dispatch(SET_BREADCRUMB, [
      { title: `${this.$t("MENU.MANGROVE_INFO.NAME")}` }
    ]);
    if (this.isClearPagination) {
      this.$store.commit(CLEAR_PAGINATION);
    }
    this.isClearPagination = true;
    this.fetchData();
   this.setDataId(0);

  },
  methods: {
      setDataId(data) {
      this.$store.commit(SET_STATE_PRAM_M_LOCATION, { mangrove_location_id: data});
    },
    sortChange(event) {
      this.pagination.isDesc = event.sortDesc;
      this.pagination.orderBy = event.sortBy;
      this.fetchData();
    },
    setMap() {
    for (const item of this.items) {
      this.gmap.markers.push({
        id: 1,
        position: {
          lat: Number(item.latitude),
          lng: Number(item.longitude),
        },
      })
         }


      this.gmap.center = this.gmap.markers[0].position
      this.gmap.infowindow = this.gmap.markers[0].position
    },
    getParams() {
      return {
        page: this.pagination.page.toString(),
        perPage: this.pagination.perPage.toString(),
        isDesc: this.pagination.isDesc.toString(),
        filter: this.pagination.filter.toString(),
        filterBy: `${this.fields
          .map(item => {
            if (item.isFilter) return item.key;
          })
          .filter(item => !!item)}`,
        select: `${this.select}`,
        include: `${this.include}`,
      };
    },
    fetchData() {
      this.$store
        .dispatch(PAGINATION_MANGROVE_LOCATION_DATA, { params: this.getParams() })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.items = data.data.data;
            this.total = data.data.total;
            this.setMap()
            if (this.total > 0 && this.items.length < 1) {
              this.$store.commit(CLEAR_PAGINATION);
              this.fetchData();
            }
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              showConfirmButton: true,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
              confirmButtonColor: '#840000'
            });
          }
          this.isBusy = false;
        })
        .catch(error => {
          Swal.fire({
            icon: "error",
            text: `${error.error}`,
            showConfirmButton: true,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
            confirmButtonColor: '#840000'
          });
          this.isBusy = false;
        });
    },
    updateStatus(event, id) {
      this.isBusy = true;
      this.$store
        .dispatch(PUT_MANGROVE_LOCATION_STATUS_DATA, {
          id,
          data: {
            status_id: event.value ? 1 : 2
          }
        })
        .then(({ data }) => {
          if (data.status === "success") {
            Swal.fire({
              icon: "success",
              text: `${this.$t("RESPONSE_MESSAGE." + data.data)}`,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
              confirmButtonColor: '#840000'
            });
            setTimeout(() => {
              this.fetchData();
            }, 500);
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
              confirmButtonColor: '#840000'
            });
          }
          this.isBusy = false;
        })
        .catch(error => {
          Swal.fire({
            icon: "error",
            text: `${error.error}`,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
            confirmButtonColor: '#840000'
          });
          this.isBusy = false;
        });
    },
    removeData(id) {
      Swal.fire({
        text: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.ACTION.DELETE.DESC")}`,
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
        cancelButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_CANCEL")}`,
        confirmButtonColor: '#840000',
      }).then(result => {
        if (result.isConfirmed) {
          this.$store
            .dispatch(DELETE_MANGROVE_LOCATION_DATA, { id })
            .then(({ data }) => {
              if (data.status === "success") {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.data)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000',
                });
                this.fetchData();
              } else if (data.status === "error" && data.error) {
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000',
                });
              }
              this.isBusy = false;
            })
            .catch(error => {
              Swal.fire({
                icon: "error",
                text: `${error.error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
              this.isBusy = false;
            });
        }
      });
    }
  }
};
</script>
